import classNames from 'classnames';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import { EMouseLeaveDelay, Tooltip } from '@feathr/components';

import SelectOption from './SelectOption';
import type { ISelectOptionProps } from './SelectOptions.types';

import * as styles from './SelectOptions.css';

/** The fields this renderer reads; each caller keeps its own wider option type. */
export interface ITooltipOptionData {
  description?: string;
  name: string;
  tooltip?: ReactNode;
}

/** Renders an option's name plus an optional description line, an optional hover tooltip, or both. */
function TooltipOption<T extends ITooltipOptionData>(
  props: Readonly<ISelectOptionProps<T>>,
): JSX.Element {
  const {
    data: { description, name, tooltip },
    isDisabled,
  } = props;

  const option = (
    <SelectOption {...props}>
      {name}
      {!!description && (
        <div
          className={classNames(styles.description, {
            [styles.descriptionDisabled]: isDisabled,
          })}
        >
          <p>{description}</p>
        </div>
      )}
    </SelectOption>
  );

  // The wrapper span Tooltip mounts is inline, so tooltipWrapper restores the option's own box.
  return tooltip ? (
    <Tooltip className={styles.tooltipWrapper} closeDelay={EMouseLeaveDelay.Link} title={tooltip}>
      {option}
    </Tooltip>
  ) : (
    option
  );
}

export default TooltipOption;
